module.exports = __webpack_public_path__ + "img/geo-zones-4.c7282037.gif";